import { defineStore } from 'pinia';
import { DevelopersApi } from '@/api/Developers.api';
import { Project } from '@/types';
import { getDocsUrl } from '@/utils/docsUrl';

const useDocsStore = defineStore('DocsStore', {
  state: () => ({
    projects: [] as Project[],
    docsLoading: true,
  }),

  getters: {
    getDocAsMenuItems: (state) => {
      return state.projects.map(i => {
        const label = i.label || i.project;

        return {
          projectName: i.project,
          label,
          preview: i.preview,
          description: i.description || '',
          tags: i.tags || [],
          latestVersion: i.latestVersion || null,
          docsUrl: i.latestVersion ? getDocsUrl(i.project, i.latestVersion) : '',
        };
      });
    },
  },

  actions: {
    async getDocsAction(): Promise<void> {
      this.docsLoading = true;
      this.projects = await DevelopersApi.getProjects();
      this.docsLoading = false;
    },

    deleteDocFormStore(projectName: string): void {
      this.projects = this.projects.filter(i => i.project !== projectName);
    },
  },
});

export default useDocsStore;
